
import pageHelper from '../../../helper/page-helper';

const React = require('react');
require('./quick-menu.scss');
const helper = require('../../../helper/dish-helper');
const cartHelper = require('../../../helper/order-dinner-cart-helper');
const shopId = helper.getUrlParam('shopId');
const type = helper.getUrlParam('type') || 'TS';
const config = require('../../../config');
const ServiceBell = require('./service-bell.jsx');
const tradeDetailUncheckUrl = `${config.tradeDetailUncheckURL}?type=${type}&shopId=${shopId}`;
const dishCart4DinnerUrl = `${config.dishCart4DinnerURL}?type=${type}&shopId=${shopId}`;
const isShopOpen = require('../../../helper/dish-helper.js').isShopOpen;

const tableKey = cartHelper.getTableInfoInSessionStorage(shopId).tableKey || '';
const tableId = cartHelper.getTableInfoInSessionStorage(shopId).tableId || '';

const QuickMenu = React.createClass({
  displayName: 'QuickMenu',
  propTypes: {
    callBell: React.PropTypes.func.isRequired,
    clearBell: React.PropTypes.func.isRequired,
    callMsg: React.PropTypes.object.isRequired,
    callAble: React.PropTypes.bool.isRequired,
    dishes: React.PropTypes.array.isRequired,
    serviceStatus: React.PropTypes.object,
    openTimeList: React.PropTypes.array,
    showErrMsgFunc: React.PropTypes.func,
    clearErrorMsg: React.PropTypes.func,
    cancelCallMsg: React.PropTypes.func,
    updateCanCall: React.PropTypes.func,
    tableInfo: React.PropTypes.object.isRequired,
    shopInfo: React.PropTypes.object,
  },

  getInitialState() {
    return {
      expandMenu: true,
      animate: '',
    };
  },

  setCallClass(enableCallService) {
    if (!enableCallService) {
      return 'call-menu-gray';
    }
    return '';
  },

  goToDetail(enableOrder, isLogin) { // 进入订单详情页
    const orderId = sessionStorage.orderId || '';
    // 不带桌台的时候
    if (!tableKey && !tableId) {
      if (enableOrder && isLogin) {
        location.href = `${tradeDetailUncheckUrl}&orderId=${orderId}`;
      }
    } else { // 带桌台的时候
      if (enableOrder) {
        location.href = `${tradeDetailUncheckUrl}&orderId=${orderId}`;
      }
    }
  },

  goToPay(enablePay) { // 进入结算页面
    const orderId = sessionStorage.orderId || '';
    if (enablePay) {
      location.href = `${config.settlement4DinnerURL}?type=TS&shopId=${shopId}&tradeId=${orderId}`;
    }
  },

  jumpDetail(evt, num) {
    const { openTimeList, showErrMsgFunc } = this.props;
    if (!isShopOpen(openTimeList)) {
      showErrMsgFunc('非常抱歉，门店已打烊');
      return false;
    }

    evt.preventDefault();
    const { serviceStatus } = this.props;
    if (num) {
      if (serviceStatus.isLogin) {
        location.href = `${dishCart4DinnerUrl}`; // 跳转到购物车详情页面
      } else {
        pageHelper.navigateToLoginPage({
          shopId,
          returnUrl: encodeURIComponent(dishCart4DinnerUrl),
        }); // 跳转到登录页面
      }
    }
    return true;
  },

  bellMenu() {
    const status = this.state.expandMenu;
    if (status) {
      this.setState({ animate: '' }, () => {
        setTimeout(() => {
          this.setState({ expandMenu: false });
        }, 400);
      });
    } else {
      this.setState({ expandMenu: true }, () => {
        this.setState({ animate: 'animation' });
      });
    }
  },
  render() {
    const { expandMenu, animate } = this.state;
    const { callBell, clearBell, callMsg, callAble, dishes, serviceStatus, openTimeList,
      cancelCallMsg, updateCanCall, tableInfo, shopInfo, showErrMsgFunc, isFucBell } = this.props;
    // 逻辑判断
    const enableCallService = serviceStatus.enableCallService;

    const orderedDishes = helper.getOrderedDishes(dishes);
    const dishesCount = helper.getDishesCount(orderedDishes);
    let cartIconClass = 'cart-icon cart-icon--tiny cart-icon--fixed';
    if (!dishesCount || !isShopOpen(openTimeList)) {
      cartIconClass += ' cart-icon--transparent';
    }
    return (
      <ServiceBell
        enableCallService={enableCallService}
        callBell={callBell}
        clearBell={clearBell}
        callMsg={callMsg}
        animate={animate}
        expandMenu={expandMenu}
        callAble={callAble}
        cancelCallMsg={cancelCallMsg}
        updateCanCall={updateCanCall}
        tableInfo={tableInfo}
        serviceSupply={shopInfo.serviceSupply}
        showErrMsgFunc={showErrMsgFunc}
        isFucBell={isFucBell}
      />
    );
  },
});
module.exports = QuickMenu;



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/quick-menu.jsx